'use strict';

/**
 * @extends {ngtk.model.Base}
 */
ngtk.model.Item = ngtk.model.Base.extend({

    _data: {},

    _initialize: function() {
        this._data = {};
    },

    replace: function(itemData) {
        return this.clean().merge(itemData);
    },

    merge: function(mergeData) {
        angular.extend(this._data, mergeData);
        return this;
    },
    
    clean: function() {
        this._cleanObject('_data');
        return this;
    },

    get: function(path) {
        if (!path) {
            var result = {};
            angular.forEach(this._data, function(value, key) {
                if (key.substr(0, 1) != '$') {
                    result[key] = value;
                }
            });
            return result;
        }
        if (!angular.isArray(path)) {
            path = ('' + path).split('.').filter(function(v) {
                return v.length > 0;
            });
        }
        var ptr = this._data;
        for (var i = 0; i < path.length; ++i) {
            var element = path[i];
            if (angular.isUndefined(ptr[element])) {
                return undefined;
            }
            ptr = ptr[element];
        }
        return ptr;
    },

    equals: function(item) {
        var id;
        if (item instanceof this.constructor) {
            id = item.getId();
        } else if (item) {
            id = this._extractIdFromItemData(item);
        }
        return angular.isDefined(id) && this.getId() == id;
    },

    exportData: function() {
        if (angular.isObject(this._data) && !this._data.$model) {
            this._data.$model = this;
        }
        return this._data;
    },

    _wireScope: function(scope, scopeInnerPtr, scopeInnerElement) {
        scopeInnerPtr[scopeInnerElement] = this._data;
        scopeInnerPtr[scopeInnerElement].$model = this;
    },

    _setFromApiResult: function(itemData) {
        this.replace(this._parseItemData(itemData));
    },

    _parseItemData: function(itemData) {
        angular.forEach(itemData, function (value, key) {
            if (key.match(/^is_/)) {
                itemData[key] = value == 1;
            } else if (key.match(/_id$/)) {
                if (angular.isString(value) && value.match(/^[0-9]+$/)) {
                    itemData[key] = parseInt(value);
                }
            }
        });
        return itemData;
    },

    _extractIdFromItemData: function(itemData) {
        throw new Error("Abstract method not implemented");
    }

});
